import { Suspense, useEffect, useState } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Paper } from "@mui/material";
import { ResumenTableForm } from "../components/resumenTableForm";
import { DividendosImportForm } from "../components/dividendosImportForm";
import UseTablaDesarrollo from "../hooks/useTablaDesarrollo";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { useDetalleTablaDesarrollo } from "../../../../context/tablaDesarrolloContext";

export default function DetalleTablaDesarrollo(){

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Maestros', url: `/maestros` },
        { label: 'Tablas de desarrollo', url: '/maestros/tabla-desarrollo' },
        { label: 'Detalle', active: true },
    ];

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const { resumen, dividendos, consultarTabla, exportarTabla} = UseTablaDesarrollo();
    const navigate = useNavigate();
    const { idTablaDesarrollo } = useDetalleTablaDesarrollo();

    const onCancel = () => {
        navigate('/maestros/tabla-desarrollo');
    }

    const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (idTablaDesarrollo){
            exportarTabla(idTablaDesarrollo);
        }
    }

    useEffect(() => {
        if (idTablaDesarrollo){
            consultarTabla(idTablaDesarrollo);
        }     
    }, [idTablaDesarrollo])
    
    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <ConfirmationModal
                    onHide={() =>
                        setModalConfirmacion({ ...modalConfirmacion, show: false })
                    }
                    onConfirm={modalConfirmacion.metodo}
                    title={modalConfirmacion.title}
                    show={modalConfirmacion.show}
                    message={modalConfirmacion.message}
                />
                <Paper elevation={3} sx={{ p: 3 }}>
                    <ResumenTableForm resumen={resumen} isShowing={true}/>
                    <form onSubmit={onSubmit}>
                        <DividendosImportForm isSubmitEnabled={dividendos && dividendos.length > 0} dividendos={dividendos}
                                    onCancel={onCancel} isShowing={true}/> 
                    </form>      
                </Paper>
            </Box>
        </Suspense>
    );
}